import { REFERENCE_CHILD_OF, Span, SpanContext, SpanOptions, Tracer } from 'opentracing'
import { CustomSpan } from './custom-span'
import { CustomSpanContext } from './custom-span-context'
import { SendTraceEvents, TraceEvent } from './trace-event'

export class CustomTracer extends Tracer {
  private _eventSender: SendTraceEvents

  constructor(eventSender: SendTraceEvents) {
    super()
    this._eventSender = eventSender
  }

  public sendEvent(traceEvent: TraceEvent) {
    this._eventSender.send(traceEvent)
  }

  protected _startSpan(name: string, spanOptions: SpanOptions): Span {
    return new CustomSpan(name, this, this.spanContext(spanOptions), Date.now())
  }

  protected _inject(spanContext: SpanContext, _format: string, carrier: any): void {
    carrier['X-TraceId'] = spanContext.toTraceId()
    carrier['X-SpanId'] = spanContext.toSpanId()
  }

  // copied from https://github.com/openzipkin/zipkin-js/blob/08f86b63a5fd7ded60762f537be1845ede588ffa/packages/zipkin/src/tracer/randomTraceId.js
  private randomNumber() {
    const digits = '0123456789abcdef'
    let n = ''
    for (let i = 0; i < 16; i++) {
      const rand = Math.floor(Math.random() * 16)
      n += digits[rand]
    }

    return n
  }

  private spanContext(spanOptions: SpanOptions): CustomSpanContext {
    if (spanOptions.references) {
      const childOf = spanOptions.references.find((reference) => reference.type() === REFERENCE_CHILD_OF)
      if (childOf) {
        const parent = childOf.referencedContext()

        return new CustomSpanContext(parent.toTraceId(), this.randomNumber(), parent.toSpanId())
      }
    }

    return new CustomSpanContext(this.randomNumber(), this.randomNumber(), '')
  }
}
